import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import environment from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CookieService } from './cookie.service';
import { MakeAClaimPayload } from '../interfaces/strapi';
import { IInternationalStudentContactUsPayload } from '../interfaces/api';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public url: string = '';

  public errorMsg = '';

  constructor(
    private readonly http: HttpClient,
    private readonly cookie: CookieService
  ) {
    this.url = `${environment.apiHost}/${environment.apiPath}/${environment.apiVersion}`;
  }

  public contact(
    category: string,
    title: string,
    message: string,
    email: string
  ): Observable<Object> {
    const endpoint = `${this.url}/guest/help/contact`;

    return this.http.post(endpoint, { category, title, message, email });
  }

  public internationalStudentMakeAClaim(
    payload: MakeAClaimPayload
  ): Observable<Object> {
    const endpoint = `${this.url}/help/make-a-claim`;
    return this.http.post(endpoint, payload);
  }

  public internationalStudentContactUs(
    payload: IInternationalStudentContactUsPayload
  ) {
    const endpoint = `${this.url}/help/international-student-contact-us`;
    return this.http.post(endpoint, payload);
  }

  getCSRFHeader(): Object {
    const csrfToken = this.cookie.getCookie('XSRF-TOKEN');
    if (csrfToken.length) {
      return {
        headers: new HttpHeaders({
          'X-XSRF-TOKEN': csrfToken.replace('%3D', '='),
        }),
      };
    }

    return {};
  }
}
